import {combineReducers} from 'redux';
import mapSceneReducer, {MapSceneCombinedReducerState} from './scenes/MapScene/reducer';
import userSettingsReducer, {UserSettingsReducerState} from './modules/UserSettingsReducer/reducer';
import {keycloakAuthenticationReducer, KeycloakAuthenticationState} from '@ndw/react-keycloak-authentication';
import notificationModuleReducer, {NotificationReducerState} from './modules/NotificationReducer/reducer';

export interface RootState {
    keycloakAuthentication: KeycloakAuthenticationState;
    mapScene: MapSceneCombinedReducerState;
    notification: NotificationReducerState;
    userSettings: UserSettingsReducerState;
}

const rootReducer = combineReducers<RootState>({
    keycloakAuthentication: keycloakAuthenticationReducer,
    mapScene: mapSceneReducer,
    notification: notificationModuleReducer,
    userSettings: userSettingsReducer,
});

export default rootReducer;
